// sagas.js
import { takeLatest, put } from 'redux-saga/effects';
import { getUsersSuccess,getUsersError, createUserSuccess, createUserError, editUserSuccess, editUserError, changeStatusError, deleteUserError } from './action';
import { changeStatus, creatNewUser, creatNewUserHasRole, editUser, getAllUser } from '../../api';
import { CREATE_USER, EDIT_USER, GET_ALL_USERS, CHANGE_USER_STATUS, DELETE_USER } from '../actionTypes';
import SweetAlert from 'sweetalert2';
import { toast } from 'react-toastify';

function* getUsersSaga(action) {
  try {
    const { page, rowsPerPage, searchText, columnFilters, sorting, setCount, setData, setIsLoading, dataType } = action.payload;
   setIsLoading(true);
    const data = yield getAllUser(page , rowsPerPage , searchText, columnFilters, sorting, dataType);
      if (data) {
          yield put(getUsersSuccess(data.data?.result?.users));
          setData(data.data?.result?.users);
          setCount(data.data?.result?.totalRows);   
          setIsLoading(false);
        }
  } catch (error) {
    yield put(getUsersError(error)); 
  

  }
}

function* createUserSaga(action) {
  try {
    const { profileData, roles, toggleModal, refresh, setIsSubmitting } = action.payload;
    // console.log("reached");
    // console.log("profileData", profileData);
    setIsSubmitting(true);
    const createUserResponse = yield creatNewUser( profileData );
      // console.log("createUserResponse",createUserResponse)
      if (createUserResponse.status === 200) {
        roles.forEach((role) => {
          creatNewUserHasRole({ role_id: role.value, user_id: createUserResponse.data.result.user_id })
            .then().catch((error) => toast.error(error.response.data.error))
        })
        SweetAlert.fire({ title: "User Created Successfully", icon: "success" }).then((result) => {
          // Perform actions after the SweetAlert is closed
          // You can call your function or perform any other logic here          
          setIsSubmitting(false);
          toggleModal();
          refresh();
          
        });
      }
      if (createUserResponse) {
        // yield put(createUserSuccess(data.data?.result?.users));
        yield put(createUserSuccess('success redux message'));
        setIsSubmitting(false);
        
      }
  } catch (error) {
    toast.error(error.response.data.error)
    yield put(createUserError(error)); 
    action.payload.setIsSubmitting(false);

  }
}

function* editUserSaga(action) {
  try {
    const { userId, profileData, roles, toggleModal, refresh, setIsSubmitting } = action.payload;
    // console.log("reached");
    // console.log("profileData", profileData);
    setIsSubmitting(true);
    const editUserResponse = yield editUser( userId, profileData );
      // console.log("editUserResponse",editUserResponse)
      if (editUserResponse.status === 200) {
        if(roles){
          roles.forEach((role) => {
            creatNewUserHasRole({ role_id: role.value, user_id: userId })
            .then().catch((error) => toast.error(error.response.data.error))
          })
        }
        SweetAlert.fire({ title: "User Updated Successfully", icon: "success" }).then((result) => {
          // Perform actions after the SweetAlert is closed
          // You can call your function or perform any other logic here          
          setIsSubmitting(false);
          toggleModal();
          refresh();
          
        });
      }
      if (editUserResponse) {
        // yield put(createUserSuccess(data.data?.result?.users));
        yield put(editUserSuccess('success redux message'));
        setIsSubmitting(false);
        
      }
  } catch (error) {
    toast.error(error.response.data.error)
    yield put(editUserError(error)); 
    action.payload.setIsSubmitting(false);
    // SweetAlert.fire({ title: "Error", text: error.response.data.error, icon: "error" });

  }
}

function* changeStatusSaga(action) {
  try {
    const { userId, statusData, refresh } = action.payload;
  
    const statusResponse = yield changeStatus( userId, statusData );
    
      if (statusResponse.status === 200) {
        let alertText = '';
        if (statusData.hasOwnProperty("is_deleted")) {
          alertText = 'User Deleted Successfully';
        }else{
          alertText = 'Status Updated Successfully';
        }

        SweetAlert.fire({ title: alertText , icon: "success" }).then((result) => {        
          refresh();
          
        });
      }
      
  } catch (error) {
    toast.error(error.response.data.error)
    yield put(changeStatusError(error)); 
    action.payload.setIsSubmitting(false);
    // SweetAlert.fire({ title: "Error", text: error.response.data.error, icon: "error" });

  }
}

function* deleteUserSaga(action) {
  try {
    const { userId, statusData, refresh } = action.payload;
  
    const statusResponse = yield changeStatus( userId, statusData );
        
      if (statusResponse.status === 200) {
        SweetAlert.fire({ title: "User Deleted Successfully.", icon: "success" }).then((result) => {        
          refresh();
        });
      }
      
  } catch (error) {
    toast.error(error.response.data.error)
    yield put(deleteUserError(error)); 
  }
}

export function* watchUsersData() {
  yield takeLatest(GET_ALL_USERS, getUsersSaga);
  yield takeLatest(CREATE_USER, createUserSaga); 
  yield takeLatest(EDIT_USER, editUserSaga); 
  yield takeLatest(CHANGE_USER_STATUS, changeStatusSaga); 
  yield takeLatest(DELETE_USER, deleteUserSaga); 
}